import React, { FC, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { updateBenefitEnrollments } from "../../../../actions/userActions"
import { useBenefitEnrollmentFlow } from "./BenefitEnrollmentFlowModal"
import { DeductibleStatus } from "carrot-api/types/DeductibleStatus"
import { Spacer } from "../../atoms/Atoms"
import { CenteredLoadingIndicator } from "../../molecules/Molecules"
import { getDeductibleStatus } from "../../../../reducers/userInfo"
import { Steps } from "./Workflow/Steps"
import { waitForMinimumDelay } from "./utils"
import useInitialSetup from "./hooks/useInitialSetup"
import { useProgressTracker } from "../ProgressTracker"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"

const ViewName = Steps.PROCESS_MEMBER_ENROLLMENT

function useLoadBenefits() {
  const { needsEnrollment, setNeedsEnrollment, connectInsuranceInProgress } = useBenefitEnrollmentFlow()
  const { setNextStep } = useStateMachine()
  const deductibleStatus = useSelector(getDeductibleStatus)
  const shouldInitiateEnrollment = needsEnrollment && !connectInsuranceInProgress
  const [loading, setLoading] = useState(shouldInitiateEnrollment)
  const dispatch = useDispatch()

  function requestBenefits() {
    if (shouldInitiateEnrollment) {
      return waitForMinimumDelay(updateBenefitEnrollments(dispatch), 1000)
    }
  }

  function loadBenefits(response) {
    if (connectInsuranceInProgress || !needsEnrollment) {
      const retVal =
        deductibleStatus === DeductibleStatus.CarrotSpecificDeductible ||
        deductibleStatus === DeductibleStatus.ExternalDeductible
      setNextStep(Steps.PROCESS_MEMBER_ENROLLMENT, retVal)
    } else {
      const retVal =
        response?.deductibleStatus === DeductibleStatus.CarrotSpecificDeductible ||
        response?.deductibleStatus === DeductibleStatus.ExternalDeductible
      setLoading(false)
      setNeedsEnrollment(false)
      setNextStep(Steps.PROCESS_MEMBER_ENROLLMENT, retVal)
    }
  }

  useInitialSetup(requestBenefits, loadBenefits)

  return {
    loading
  }
}

const ProcessMemberEnrollmentView: FC = () => {
  const { setProgress } = useProgressTracker()
  const { loading } = useLoadBenefits()

  useStateMachine(ViewName, null)
  setProgress(1, "YOUR INSURANCE COVERAGE")

  return (
    <>
      <Spacer height={8} />
      {loading && <CenteredLoadingIndicator />}
      <Spacer height={8} />
    </>
  )
}

export { ProcessMemberEnrollmentView }
